export default __webpack_public_path__ + "static/media/image4.1d3694a4.jpg";